<template>
  <div>
    <FixedButton>
      <el-button type="primary" @click.stop="add" size="small">新建</el-button>
    </FixedButton>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        :needIndex="true"
        :tableRowClassName="tableRowClassName"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
    <RoleEdit :row="row" v-if="visible" @refresh="formSearch" :visible.sync="visible" />
    <RoleDetail
      :row="row"
      @refresh="formSearch"
      v-if="detailVisible"
      :visible.sync="detailVisible"
    />
  </div>
</template>

<script>
import formjson from './Model/Formjson.RoleManage'
import tablejson from './Model/Tablejson.RoleManage'
import formTableMixin from '@manage/mixins/formTableMixin'
// import getRoleFromPath from '@manage/mixins/getRoleFromPath'
// import { getRoleByOperationCode } from '@manage/authorized'
import RoleEdit from './RoleEdit'
import RoleDetail from './RoleDetail'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '编辑',
          type: 'edit'
          // hide: (row) => {
          //   return row.edit == 'N' || !this.updateRole
          // }
        },
        {
          name: '删除',
          type: 'delete'
          // hide: (row) => {
          //   return row.edit == 'N' || !this.deleteRole
          // }
        }
      ],
      queryApi: this.$api.system.role_list,
      visible: false,
      detailVisible: false,
      row: {}
    }
  },
  components: {
    RoleEdit,
    RoleDetail
  },
  // computed: {
  //   /********* 权限 ***********/
  //   // this.role 计算属性通过mixins: [getRoleFromPath] 注入
  //   // 导出权限
  //   roleChildList() {
  //     return this.role.childList
  //   },
  //   // 新建的权限
  //   addRole() {
  //     let val = getRoleByOperationCode(this.roleChildList, 'add')
  //     return val ? val.isPermission === 'Y' : false
  //   },
  //   // 编辑的权限
  //   updateRole() {
  //     let val = getRoleByOperationCode(this.roleChildList, 'update')
  //     return val ? val.isPermission === 'Y' : false
  //   },
  //   // 删除的权限
  //   deleteRole() {
  //     let val = getRoleByOperationCode(this.roleChildList, 'del')
  //     return val ? val.isPermission === 'Y' : false
  //   },
  //   // 详情的权限
  //   detailRole() {
  //     let val = getRoleByOperationCode(this.roleChildList, 'detail')
  //     return val ? val.isPermission === 'Y' : false
  //   },
  //   // 禁用启用的权限
  //   stateRole() {
  //     let val = getRoleByOperationCode(this.roleChildList, 'state')
  //     return val ? val.isPermission === 'Y' : false
  //   },
  //   /********* 权限 ***********/
  //   computedWidth() {
  //     let width = 50
  //     let times = 1
  //     if (this.$i18n.locale == 'en') {
  //       times = 1.2
  //     }
  //     return (
  //       [
  //         this.updateRole * width * times,
  //         this.stateRole * width * times,
  //         this.deleteRole * width * times,
  //         this.detailRole * width * times
  //       ]
  //         .filter(Boolean)
  //         .reduce((pre, next) => pre + next, 0) + ''
  //     )
  //   }
  // },
  methods: {
    tableRowClassName({ row }) {
      if (row.edit == 'N') {
        return 'system-defined'
      }
      return ''
    },
    formSearch(data) {
      this.search(data, null, this.queryApi)
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleDetail(row) {
      this.row = row
      this.detailVisible = true
    },
    handleDelete(row) {
      this.$confirm('是否删除该角色', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.system.role_delete, params)
            .then(() => {
              this.$message.success('删除成功')
              this.formSearch(this.cacheData)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.el-table {
  .system-defined {
    background: #f0f9eb;
  }
}
</style>
